(function () {

    $("#sticky-table-header").sticky(
        {
            topSpacing:0,
            zIndex: 999
        });

    $('.row-arrow').on('click', function () {
        let ele = $(this).next();
        $("html, body").animate({
            scrollTop: $(ele).offset().top - 10
        }, 500);
        return false;
    });


})();



// WEBPACK FOOTER //
// ./app/Resources/assets/js/scripts/calculation.js